import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress } from '@mui/material';

export default function ActionConfirmModal({
    open,
    onClose,
    title,
    message,
    onConfirm,
    isProcessing,
    confirmText = "Confirm",
    cancelText = "Cancel",
    confirmColor = "primary"
}) {
    return (
        <Dialog
            open={open}
            onClose={() => !isProcessing && onClose()}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle sx={confirmColor === 'error' ? { color: 'error.main' } : {}}>{title}</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2">{message}</Typography>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button 
                    onClick={onClose} 
                    disabled={isProcessing}
                    color="inherit"
                >
                    {cancelText}
                </Button>
                <Button 
                    onClick={onConfirm} 
                    variant="contained" 
                    color={confirmColor}
                    disabled={isProcessing}
                    startIcon={isProcessing ? <CircularProgress size={20} color="inherit" /> : null}
                >
                    {isProcessing ? 'Processing...' : confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
